<div
  class="ideals-skeleton"
  [class]="styleClass()"
  [ngStyle]="containerStyle()"
>
</div>
